import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";

// Get initial user data from localStorage
const storedUser = localStorage.getItem("user");
let initialUser = null;
let isInitialSessionValid = false;

if (storedUser) {
  try {
    initialUser = JSON.parse(storedUser);
    // Basic validation - check if user object has required properties
    isInitialSessionValid = !!(initialUser && initialUser.userData);
  } catch (error) {
    localStorage.removeItem("user");
  }
}

// Get initial app settings from localStorage
const loadAppSettings = () => {
  const defaultSettings = {
    appTheme: 'teal',
    appDarkMode: true,
    appGradientEnabled: true,
    appHeaderFixed: true,
    appHeaderInverse: true,
    appSidebarFixed: true,
    appSidebarGrid: false,
  };

  try {
    const storedSettings = localStorage.getItem('appSettings');
    if (storedSettings) {
      const parsedSettings = JSON.parse(storedSettings);
      const mergedSettings = {
        ...defaultSettings,
        ...parsedSettings,
        appTheme: 'teal',
        appSidebarGrid: false,
        appSidebarFixed: true,
        appHeaderFixed: true,
      };
      localStorage.setItem('appSettings', JSON.stringify(mergedSettings));
      return mergedSettings;
    }
  } catch (error) {
    console.error('Error loading app settings from localStorage:', error);
  }
  
  return defaultSettings;
};

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: {
    auth: {
      user: isInitialSessionValid ? initialUser : null,
      isAuthenticated: isInitialSessionValid,
      tokenExpiry: null,
    },
    appSettings: loadAppSettings(),
  },
});